// Utility to manage intervals and ensure cleanup on logout

const getActiveIntervals = () => {
  return JSON.parse(localStorage.getItem('activeIntervals') || '[]');
};

const addInterval = (intervalId, description = 'Interval') => {
  const intervals = getActiveIntervals();
  intervals.push(intervalId);
  localStorage.setItem('activeIntervals', JSON.stringify(intervals));
  console.log(`⏰ Started ${description} with ID: ${intervalId}`);
  return intervalId;
};

const removeInterval = (intervalId, description = 'Interval') => {
  const intervals = getActiveIntervals();
  const index = intervals.indexOf(intervalId);
  if (index > -1) {
    intervals.splice(index, 1);
    localStorage.setItem('activeIntervals', JSON.stringify(intervals));
    console.log(`⏹️ Stopped ${description} with ID: ${intervalId}`);
  }
  clearInterval(intervalId);
};

const clearAllIntervals = () => {
  const intervals = getActiveIntervals();
  console.log(`🧹 Clearing ${intervals.length} intervals`);
  intervals.forEach(intervalId => {
    clearInterval(intervalId);
  });
  localStorage.removeItem('activeIntervals');
};

// Safe setInterval that tracks the ID
const safeSetInterval = (callback, delay, description = 'Interval', ...args) => {
  const intervalId = setInterval(callback, delay, ...args);
  addInterval(intervalId, description);
  return intervalId;
};

// Safe clearInterval that also removes from tracking
const safeClearInterval = (intervalId, description = 'Interval') => {
  removeInterval(intervalId, description);
};

export {
  getActiveIntervals,
  addInterval,
  removeInterval,
  clearAllIntervals,
  safeSetInterval,
  safeClearInterval
};
